<h4 mat-dialog-title>Ajouter un mandat</h4>
<p></p>
<mat-dialog-content style="min-height: 80px;">


  <div class="row">
    <div class="col">
      <fieldset class="form-group" style="margin-top: 5px;">
        <label>Rechercher un expert :</label>
        <input class="form-control padding-search" matInput
          [matAutocomplete]="auto" [(ngModel)]="search" (ngModelChange)="onChangeResearch($event)"
          aria-label="Tappez les trois premières lettres du nom pour rechercher un expert."
          placeholder="Tappez les trois premières lettres du nom pour rechercher un expert.">
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayLabel">
            @for (user of utilisateurs; track user) {
              <mat-option (click)="selectUser(user)" [value]="user">
                <span>{{ user.nom }} - {{user.prenom}} - {{user.getRoleString()}}</span>
              </mat-option>
            }
          </mat-autocomplete>

        </fieldset>
      </div>

    </div>
    <hr>
      @if (utilisateurSelected) {
        <div>
          <mat-tab-group mat-stretch-tabs="false" class="label-tab-minimal tab-content-no-padding">
            <mat-tab label="Ajouter un mandat">
              <form [formGroup]="firstFormGroup">
                <div class="form-group">
                  <label for="nom">Nom : </label>
                  <input class="form-control" id="nom" [value]="utilisateurSelected.nom" formControlName="nom"
                    disabled="disabled">
                  </div>
                  <div class="form-group">
                    <label for="prenom">Prenom : </label>
                    <input class="form-control" id="prenom" [value]="utilisateurSelected.prenom"
                      formControlName="prenom" disabled="disabled">
                    </div>
                    <div class="form-group">
                      <label for="dateNaissance">Date de naissance : </label>
                      <input class="form-control" type="date" id="dateNaissance"
                        [value]="utilisateurSelected.dateNaissance" formControlName="dateNaissance"
                        disabled="disabled">
                      </div>
                      <div class="form-group">
                        <label for="mandattype">Poste <span class="star">*</span> : </label>
                        <mat-select class="form-control" id="mandattype" [compareWith]="compareByid"
                          formControlName="poste" required>
                          @for (mandattype of mandattypes; track mandattype) {
                            <mat-option [value]="mandattype">
                              {{ mandattype.label }}
                            </mat-option>
                          }
                        </mat-select>
                        @if (poste && poste.invalid && (poste.dirty || poste.touched)) {
                          <div
                            class="alert alert-danger">
                            @if (poste['errors']['required']) {
                              <div>
                                Le poste est requis.
                              </div>
                            }
                          </div>
                        }
                      </div>
                      <div class="form-group">
                        <label for="sousType">{{'general.instance' | translate}} <span class="star">*</span> : </label>
                        <mat-select class="form-control" id="sousType" [compareWith]="compareByid"
                          formControlName="sousType" required>
                          @for (soustype of soustypes; track soustype) {
                            <mat-option [value]="soustype">
                              {{ soustype.code }}
                            </mat-option>
                          }
                        </mat-select>
                        @if (sousType && sousType.invalid && (sousType.dirty || sousType.touched)) {
                          <div
                            class="alert alert-danger">
                            @if (sousType['errors']['required']) {
                              <div>
                                L'instance est requise.
                              </div>
                            }
                          </div>
                        }
                      </div>
                      <div class="form-group">
                        <label for="dateDebut">Date de début <span class="star">*</span> : </label>
                        <input class="form-control" id="dateDebut" type="date" placeholder="Date de début"
                          formControlName="dateDebut"
                          required data-toggle="tooltip" data-trigger="hover" data-placement="top"
                          data-title="Date Opened" data-original-title=""
                          title="">
                          @if (dateDebut.invalid && (dateDebut.dirty || dateDebut.touched)) {
                            <div
                              class="alert alert-danger">
                              @if (dateDebut['errors']['required']) {
                                <div>
                                  La date de début requise.
                                </div>
                              }
                            </div>
                          }
                        </div>
                        <div class="form-group">
                          <label for="dateFin">Date de fin <span class="star">*</span> : </label>
                          <input class="form-control" id="dateFin" type="date" placeholder="Date de fin"
                            formControlName="dateFin"
                            required data-toggle="tooltip" data-trigger="hover" data-placement="top"
                            data-title="Date Opened" data-original-title=""
                            title="">
                            @if (dateFin.invalid && (dateFin.dirty || dateFin.touched)) {
                              <div class="alert alert-danger">
                                @if (dateFin['errors']['required']) {
                                  <div>
                                    La date de fin requise.
                                  </div>
                                }
                              </div>
                            }
                          </div>
                        </form>
                      </mat-tab>
                      <mat-tab
                        [label]="'Mandats actuels ('+ (utilisateurSelected.mandats ? utilisateurSelected.mandats.length:0) +')'">
                        @if (utilisateurSelected) {
                          <app-mandats [profil]="utilisateurSelected"
                          [simpleDisplay]="true"></app-mandats>
                        }
                      </mat-tab>
                    </mat-tab-group>
                  </div>
                }
              </mat-dialog-content>
              <mat-dialog-actions>
                <button mat-button [mat-dialog-close]="false">Annuler</button>
                <button mat-raised-button [disabled]="!firstFormGroup.valid" color="primary" type="submit" (click)="addMandat()">
                  Ajouter
                </button>
              </mat-dialog-actions>
